import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../redux/store';

interface AuthGuardProps {
  children: React.ReactNode;
}

const AuthGuard: React.FC<AuthGuardProps> = ({ children }) => {
  const { token, isAuthenticated } = useSelector((state: RootState) => state.auth);

  useEffect(() => {
    if (!token || !isAuthenticated) {
      // במקום navigate, פשוט reload לדף הבית שיעביר ללוגין
      if (window.location.pathname !== '/login') {
        window.location.href = '/login';
      }
    }
  }, [token, isAuthenticated]);

  if (!token || !isAuthenticated) {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '100vh',
        background: 'var(--background-base)'
      }}>
        <div>מעביר לדף התחברות...</div>
      </div>
    );
  }

  return <>{children}</>;
};

export default AuthGuard;